import RequestContextService from '../RequestContextService.js';
import getBaseUrl from './getBaseUrl.js';

export default async function upgradeAuthToken() {
  const requestContext = RequestContextService.get();

  // If the user has more than one tab opened, the token may have been upgraded already.
  // If so, we don't need to upgrade it.
  if (requestContext.refreshToken != null || requestContext.authTokenExpirationDate != null) {
    return {
      authToken: requestContext.authToken,
      refreshToken: requestContext.refreshToken,
      authTokenExpirationDate: requestContext.authTokenExpirationDate
    };
  }

  const baseUrl = getBaseUrl();
  const response = await fetch(`${baseUrl}/authentication-upgrade-token`, {
    headers: {
      Accept: 'application/json',
      'Accept-encoding': 'gzip',
      Authorization: requestContext.authToken
    },
    method: 'POST',
    keepalive: true
  });

  if (!response.ok) {
    throw Object.assign(
      new Error(`Error while upgrading authToken : ${response.status} ${response.statusText}`),
      { status: response.status }
    );
  }

  const { authToken, authTokenExpirationDate, refreshToken } = await response.json();
  return { authToken, authTokenExpirationDate, refreshToken };
}
